import(/* webpackMode: "eager" */ "/vercel/path0/app/confidentialite/page.tsx");
